<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='titleIcon'
      :titleIconColor='titleIconColor'
      :showEdit='showEdit'
      showHelp
      :helpText='helpText'
      @edit='openEdit'
    >
      <template v-slot:toolbarButtons >
        <span v-if='showPendingSaveText' class='mr-1 primary--text font-italic font-weight-bold'>(Pending Save)</span>
        <span v-if='showPreCheckText' class='mx-1 purple--text font-weight-bold'>Pre-check</span>
      </template>
      <v-card-text>
        <span v-if='!project.customer_notes' class='font-italic grey--text text--lighten-2'>None...</span>
        <span>{{ project.customer_notes }}</span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='titleIcon'
      :icon='titleIconColor'
      :iconColor='titleIconColor'
      :showDialog='showDialog'
      :saveText='saveText'
      @cancel='showDialog = false'
      @save='saveChanges'
    >
      <v-textarea outlined auto-grow v-model='projectCopy.customer_notes'></v-textarea>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'customer-notes',
  props: {
    project: {
      required: true
    },
    showEdit: {
      required: false,
      type: Boolean,
      default: true
    },
    showPendingSaveText: {
      required: false,
      type: Boolean,
      default: false
    },
    showPreCheckText: {
      required: false,
      type: Boolean,
      default: false
    },
    saveText: {
      required: false,
      type: String,
      default: "Save"
    },
    titleIcon: {
      required: false,
      type: String,
      default: "mdi-text-box"
    },
    titleIconColor: {
      required: false,
      type: String,
      default: "pink"
    }
  },
  data: () => ({
    isLoading: false,
    title: 'Notes to Customer',
    projectCopy: {},
    showDialog: false,
    helpText: "These notes will be included on correspondence with the customer.<br><br>They usually include additional service details that are outside the normal scope of work.<br><br>These notes are often very similar to the field instructions, but written more formally and directed specifically towards the customer."
  }),
  methods: {
    openEdit () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    saveChanges () {
      this.$emit('update', this.projectCopy)
      this.showDialog = false
    }
  }
}
</script>
